import React, { Component } from 'react';
import { FormattedNumber } from 'react-intl';

interface IProps {
  list: any[];
  prop: string;
}

class Total extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.total = this.total.bind(this);
  }

  total = (list: any[], props: string) => {
    let total = 0;

    if (list && list.length && props) {
      list.forEach((item: object) => {
        return (total += item[props] && parseFloat(item[props]));
      });
    }

    return total;
  };

  render() {
    return <FormattedNumber value={this.total(this.props.list, this.props.prop)} format='BRL' />;
  }
}

export default Total;
